exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".data-table {\n  width: 100%; }\n\n.data-table .data-table__header .row {\n  display: -ms-flexbox;\n  display: flex; }\n  .data-table .data-table__header .row .form-group {\n    margin-bottom: 10px; }\n\n.data-table__footer {\n  padding: 15px 10px 5px;\n  background-color: #f7f7f7; }\n  .data-table__footer pagination {\n    float: left;\n    padding-left: 25px; }\n\n.data-table__footer .btn-toolbar {\n  float: right;\n  margin-right: 25px; }\n\n.mensagemTabelaSemRegistros {\n  text-align: center;\n  padding-top: 50px;\n  padding-bottom: 50px;\n  font-size: 16px;\n  font-weight: bold;\n  color: #d7d7d7;\n  background-color: #ffffff; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Disco D/Projetos/central-cliente/src/app/angular-base-ui/tabela-paginacao/tabela-paginacao.component.scss
// module id = ../../../../../src/app/angular-base-ui/tabela-paginacao/tabela-paginacao.component.scss
// module chunks = 1